import { render, staticRenderFns } from "./SettingsBrowserPreview.vue?vue&type=template&id=93365410&scoped=true&"
import script from "./SettingsBrowserPreview.vue?vue&type=script&lang=js&"
export * from "./SettingsBrowserPreview.vue?vue&type=script&lang=js&"
import style0 from "./SettingsBrowserPreview.vue?vue&type=style&index=0&id=93365410&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93365410",
  null
  
)

export default component.exports